import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  ACESSO_SISTEMA_REGISTRAR_BEGIN,
  ACESSO_SISTEMA_REGISTRAR_SUCCESS,
  ACESSO_SISTEMA_REGISTRAR_FAILURE,
  ACESSO_SISTEMA_REGISTRAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function registrar(registro, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: ACESSO_SISTEMA_REGISTRAR_BEGIN,
    data: registro,
    callback,
  };
}

export function dismissRegistrarError() {
  return {
    type: ACESSO_SISTEMA_REGISTRAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on ACESSO_SISTEMA_REGISTRAR_BEGIN actions
export function* doRegistrar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioApi = new Services['UsuarioApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioApi.registro(action.data);
  } catch (err) {
    yield put({
      type: ACESSO_SISTEMA_REGISTRAR_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(ACESSO_SISTEMA_REGISTRAR_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: ACESSO_SISTEMA_REGISTRAR_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(ACESSO_SISTEMA_REGISTRAR_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchRegistrar() {
  yield takeLatest(ACESSO_SISTEMA_REGISTRAR_BEGIN, doRegistrar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case ACESSO_SISTEMA_REGISTRAR_BEGIN:
      return {
        ...state,
        registro: {},
        registrarPending: true,
        registrarError: null,
      };

    case ACESSO_SISTEMA_REGISTRAR_SUCCESS:
      return {
        ...state,
        registro: action.data,
        registrarPending: false,
        registrarError: null,
      };

    case ACESSO_SISTEMA_REGISTRAR_FAILURE:
      return {
        ...state,
        registrarPending: false,
        registrarError: action.data.error,
      };

    case ACESSO_SISTEMA_REGISTRAR_DISMISS_ERROR:
      return {
        ...state,
        registrarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/acesso-sistema/redux/registrar.js